import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentAwaitingLabel() {
  return (
    <FulfillmentQueue
      title="Awaiting Label"
      statusFilter="awaiting_label"
      emptyMessage="No orders awaiting labels"
    />
  );
}
